import React from 'react';
import styled from 'styled-components';
import { useMaxImageBanners } from './use-image-banner-form';

export function ImageBannerLimit(): JSX.Element {
  const maxImageBanners = useMaxImageBanners();

  return (
    <Container>
      <Body>
        <b>LIMIT REACHED</b> - The image banner can only support up to {maxImageBanners} images at a time.
      </Body>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  background: #fffdea;
  padding: 12px 24px;
  color: #75725b;
  border: 1px solid #eeecd4;
  border-radius: 4px;
  margin-bottom: 20px;
`;

const Body = styled.p`
  font-size: 11px;
  line-height: 1.2;

  & b {
    font-weight: 700;
  }
`;
